













































































































































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Action, Mutation } from 'vuex-class'
import Pagination, {OrderBy, PaginationInput} from '@/modules/core/model/pagination'
import Department from '@/modules/reservation/model/Department'
import DepartmentDetail from '@/modules/reservation/components/DepartmentDetail.vue'
import DepartmentTypeList from '@/modules/reservation/components/DepartmentTypeList.vue'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import {Prop, Watch} from 'vue-property-decorator'
import {VDataTableHeader, VDataTableOptions, VDataTablePagination} from '@/types';
import ConfirmDepartmentDelete from '@/modules/reservation/components/ConfirmDepartmentDelete.vue';

/**
 * Muestra al usuario la lista de departamentos registrados en la
 * publicación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        ConfirmDepartmentDelete,
        DepartmentDetail,
        DepartmentTypeList,
    },
})
export default class DepartmentList extends Vue {
    @Prop({type: Boolean, default: false})
    public hideActions: boolean

    @Prop({type: Boolean, default: false})
    public selectable: boolean

    /**
     * Paginación actualmente mostrada al usuario
     */
    @State(state => state.reservation.departmentPagination)
    public pagination: Pagination<Department>

    @Action('reservation/loadDepartmentPagination')
    public loadPagination: (input: PaginationInput) => void

    @Action('reservation/loadDepartmentTypeList')
    public loadDepartmentTypeList: () => void

    @Mutation('reservation/TOGGLE_DEPARTMENT_DETAIL')
    public toggleDetail: (toggle: boolean) => void

    @Mutation('reservation/SET_CURRENT_DEPARTMENT')
    public setCurrentDepartment: (department: Department) => void

    @Mutation('reservation/TOGGLE_DEPARTMENT_TYPE_LIST')
    public toggleDepartmentTypeList: (toggle: boolean) => void

    public loading = false
    public searchBy = { field: 'name', value: '' }

    public orderNumericName = true

    public mode = 1

    public get grid (): boolean {
        return this.mode === 0
    }

    /**
     * Almacena los parámetros de paginación de la tabla
     */
    public tablePagination: VDataTablePagination | object = {}

    public tableOptions: Partial<VDataTableOptions> = {
        itemsPerPage: 20,
        sortBy: ['type', 'name'],
        sortDesc: [true, false],
    }
    public confirmDelete = false
    public departmentToDelete = new Department()

    @Watch('orderNumericName')
    public watchOrderNumericName () {
        this.loadTablePagination()
    }

    /**
     * Indica si el usuario ha introducido algún parámetro de búsqueda
     */
    public get userHasSearched (): boolean {
        return !!(this.searchBy.value && this.searchBy.field)
    }

    public get noDataText () {
        return this.loading
            ? 'Cargando lista de departamentos'
            : 'No se han registrado departamentos'
    }

    /**
     * Solicita a la aplicación una paginación de departamentos en base a la paginación
     * actual de la tabla y los filtros de búsqueda
     */
    public async loadTablePagination () {
        this.loading = true

        const input: PaginationInput = {
            page: this.tableOptions.page || 1,
            recordsPerPage: this.tableOptions.itemsPerPage || 20,
            orderBy: [],
            filters: {
                orderNumericName: this.orderNumericName,
            },
        }

        if (this.tableOptions.sortBy) {
            const orders: OrderBy[] = []
            this.tableOptions.sortBy.forEach((sort, index) => {
                orders.push({
                    field: sort,
                    direction: (this.tableOptions.sortDesc || [])[index] || false ? 'DESC' : 'ASC',
                })
            })

            input.orderBy = orders
        }

        if (this.userHasSearched) {
            input.filters!.searchBy = this.searchBy
        }

        await this.loadPagination(input)
        this.loading = false
    }

    public onSearch =  _.debounce(async function (this: DepartmentList, term: string) {
        // El término actual es igual al último término buscado, se detiene la carga
        // de la paginación
        if (term === this.searchBy.value) {
            return
        }
        this.searchBy.value = term
        await this.loadTablePagination()
    }, 800)

    @Watch('tableOptions')
    public async onTablePagination () {
       await this.loadTablePagination()
    }

    /**
     * Cabeceras para la tabla de departamentos
     */
    public get headers () {
        const headers: VDataTableHeader[] =  [
            {text: 'Identificador', value: 'id'},
            {text: 'Nombre', value: 'name'},
            {text: 'Tipo', value: 'type'},
            {text: 'Capacidad', value: 'capacity'},
            {text: 'Precio', value: 'price'},
        ]

        if (!this.hideActions) {
            headers.push({text: 'Acciones', value: 'id', sortable: false})
        }

        return headers
    }

    /**
     * Lleva al usuario a la pantalla de edición del departamento
     */
    public editDepartment (department: Department) {
        this.$router.push({
            name: 'reservations.department-detail',
            params: { id: department.id.toString() },
        })
    }

}
